import React, { useEffect } from "react";
import { Card, Form, Input, Button, Select } from "antd";
import { Option } from "antd/es/mentions";

const UserForm = ({ user, onUpdate, onDelete }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(user);
  }, [user]);

  const handleSubmit = (values) => {
    console.log("check values---->", values);
    onUpdate({ values});
  };

  return (
    <Card title="Chi tiết người dùng" style={{ marginTop: 20 }}>
      <Form form={form} onFinish={handleSubmit} layout="vertical">
        <Form.Item label="Tên đăng nhập" name="username">
          <Input  disabled/>
        </Form.Item>
        <Form.Item label="ID" name="id">
          <Input  disabled/>
        </Form.Item>
        <Form.Item label="Tên người dùng" name="full_name">
          <Input />
        </Form.Item>
        <Form.Item label="Email" name="email">
          <Input />
        </Form.Item>
      <Form.Item label="Vai trò" name="type_name">
          <Select name="type" placeholder="type_name">
            <Option value="2">Tài khoản chuyên gia</Option>
            <Option value="5">Tài khoản khách hàng</Option>
          </Select>
        </Form.Item>
        <Form.Item>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button type="primary" htmlType="submit">
              Cập nhật
            </Button>
            <Button style={{ background: "red", color: "white" }} onClick={() => onDelete(user.id)}>
              Xóa
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default UserForm;
